import styled from 'styled-components/macro';
import { colour, fontSize } from '@notonthehighstreet/toolkit/utils';
import { mediaQuery } from '../../styles/utils';

export const Container = styled.div({
  marginBottom: '20px',
});

export const Section = styled.div({
  padding: '10px 0',
  width: '100%',
});

export const TopHalf = styled.div({});

export const BottomHalf = styled.div({});

export const Option = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const OptionText = styled.div({
  width: '90%',
  textTransform: 'uppercase',
  color: '#686868',
  fontWeight: '600',
  fontSize: fontSize('s'),
  letterSpacing: '0.2px',
});

export const Purpose = styled.span({
  color: '#1b8aad',
});

export const CheckTickContainer = styled.div({
  marginTop: '2px',
});

export const CheckboxContainer = styled.div(
  {
    display: 'block',
    width: '19px',
    position: 'absolute',
    top: '20px',
    right: '13px',
    marginLeft: 'auto',
    marginRight: 'auto',
    height: '19px',
    border: `2px solid ${colour('cerulean')}`,
    borderRadius: '20%',
  },
  props => {
    let styles = {};
    if (props.status) styles = { ...styles, backgroundColor: colour('cerulean') };
    return styles;
  }
);

export const TickSvg = styled.svg({
  height: '13px',
  width: '18px',
});

export const CheckTick = styled.path({
  fill: '#ffffff',
  stroke: '#ffffff',
  strokeMiterLimit: '10',
  strokeWidth: '4px',
});

export const PleaseTick = styled.div({
  marginTop: '5px',
  color: '#686868',
  fontSize: '13px',
  opacity: '0.85',
  fontWeight: 'lighter',
});

export const Description = styled.div({
  [mediaQuery('tablet')]: {
    marginTop: '0px',
    borderTop: 'none',
  },
  color: '#686868',
  fontSize: '13px',
  marginTop: '10px',
  padding: '15px 40px 4px 0',
  opacity: '0.85',
  fontWeight: 'lighter',
  borderTop: 'solid 1px #d7dbde',
  '& a': {
    color: colour('cerulean'),
    fontWeight: '600',
    textDecoration: 'none',
  },
});

export const Error = styled.div({
  fontSize: fontSize('s'),
  letterSpacing: '-0.3px',
  width: '100%',
  padding: '16px',
  borderBottomLeftRadius: '4px',
  borderBottomRightRadius: '4px',
  boxSizing: 'border-box',
  backgroundColor: colour('linen'),
  color: colour('chestnut-rose'),
  border: '1px solid #CF4858',
  '& a': {
    color: colour('chestnut-rose'),
    textDecoration: 'underline',
  },
});

export const SubscribeCheckboxContainer = styled.div({
  marginBottom: '20px',
  position: 'relative',
});

export const WrapperSubscribeCheckBox = styled.div({
  display: 'flex',
  paddingLeft: '0px',
  [mediaQuery('tablet')]: {
    paddingLeft: '18px',
  },
});

export const IconContainer = styled.div({
  display: 'none',
  [mediaQuery('tablet')]: {
    display: 'block',
    height: 'auto',
    float: 'left',
    '& img': {
      margin: '4px 25px 0 0',
      padding: '10px 0',
      display: 'block',
      width: '45px',
      height: '75px',
    },
  },
});
